var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-google-picker"},[_c('el-button',{on:{"click":_vm.handleButtonClick}},[_c('i',{staticClass:"ddi ddi-google-drive"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }